import { render } from "./RcContainerResourceLimit.vue?vue&type=template&id=6287947b"
import script from "./RcContainerResourceLimit.vue?vue&type=script&lang=js"
export * from "./RcContainerResourceLimit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__